import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { SubscriptionStatusApi } from 'api-typings/memberships/memberships_types';
import { MembershipSubscriptionsCollection } from './membership-subscriptions.types';

export function membershipSubscriptionsBackend(): Backend<
  MembershipSubscriptionsCollection
> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'memberships/0.1/history_logs/',
      isGaf: false,
      params: {
        statuses: [SubscriptionStatusApi.ACTIVE],
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
